module.exports = __webpack_public_path__ + "img/quote-left.6a42ff8e.svg";